import { createContext } from 'react';

import TableStore from '../stores/TableStore';

export const TableContext = createContext<TableStore | undefined>(undefined);
